<template>
  <CommonHeader class="main_head_block">
    <template v-slot:header>
      <template>
        <a
          href="javascript:void(0)"
          v-if="$route.name == 'addToCampaign'"
          @click="$router.push({ path: '/productList' })"
          class="form-group bread-crumb-small"
          style="line-height: 1; margin: 0px"
          >Product ></a
        >
        <span
          v-if="$route.name == 'addToCampaign'"
          class="form-group bread-crumb-small"
          style="margin: 0px; padding-left: 10px; line-height: 1"
          >{{ prodName }}</span
        >
        <span v-else class="module_heading">
          {{ prodName }}
        </span>
        <div
          class="form-group col-md-2 pl-3"
          v-if="
            showAssociatedFilter &&
            !showFilters &&
            $route.name == 'addToCampaign'
          "
          style="margin: 0px; padding-right: 0px"
        >
          <multiselect
            v-model="selectedAssociateFilter"
            :options="associateList"
            :searchable="true"
            ref="multiselect"
            open-direction="bottom"
            :taggable="false"
            placeholder="Select Type"
            class="form-control multi-dropdown"
            selectLabel=""
            deselectLabel=""
          />
        </div>

        <div class="sel_fil_wrap two" v-if="showFilters">
          <multiselect
            v-model="selectedBrand"
            :options="brandList"
            :show-no-results="true"
            :searchable="true"
            ref="multiselect"
            label="name"
            track-by="id"
            open-direction="bottom"
            :taggable="false"
            placeholder="All Profiles"
            class="form-control multi-dropdown select_filter"
            selectLabel=""
            selectedLabel=""
            @select="getBrand($event)"
            @remove="resetFilter()"
            :allow-empty="!$store.state.isUserPrestige"
          />
        </div>

        <!-- <div class="sel_fil_wrap one" v-if="showFilters">
          <multiselect
            v-model="selectedTag"
            :options="tagsList"
            :show-no-results="true"
            ref="multiselect"
            label="title"
            track-by="id"
            open-direction="bottom"
            :taggable="false"
            placeholder="All Tags"
            class="form-control multi-dropdown select_filter"
            selectLabel=""
            selectedLabel=""
            @select="selectTag($event)"
            @remove="resetTag()"
            v-if=" $store.state.isUserPrestige==false"
          />
        </div> -->

        <!-- <div class="sel_fil_wrap two" v-if="showFilters">
          <multiselect
            v-model="selectedCountry"
            :options="countryList"
            :show-no-results="true"
            :searchable="true"
            ref="multiselect"
            open-direction="bottom"
            :taggable="false"
            placeholder="All Countries"
            class="form-control multi-dropdown select_filter"
            selectLabel=""
            selectedLabel=""
            @select="getCountry($event)"
            @remove="resetCountry()"
          />
        </div> -->
        <div v-else class="form-group col-md-2"></div>

        <!-- <div
          class="sel_fil_wrap two"
          v-if="showCampignGroupFilter ||  $store.state.isUserPrestige"
        >
          <multiselect
            v-model="selectedCampaignGroupFilter"
            :options="campaignGroupFilterList"
            :show-no-results="true"
            ref="multiselect"
            label="name"
            track-by="id"
            open-direction="bottom"
            :taggable="false"
            placeholder="All Campaign Group"
            class="form-control multi-dropdown select_filter"
            selectLabel=""
            selectedLabel=""
            @select="getCampaignListByGroup($event)"
            @remove="resetCampaignFilter()"
          /> -->

          <!-- <select
                    class="form-control brand-name"
                    id="campaignGroupFilter"
                    v-model="selectedCampaignGroupFilter"
                    @change="getCampaignListByGroup()"
                >
                    <option value>All Campaign Groups</option>
                    <option value ="1">Orphan</option>
                    <option
                        v-for="item in campaignGroupFilterList"
                        :key="item.id"
                        :value="item.id"
                    >{{ item.name }}</option>
                </select> -->
        <!-- </div>
        <div v-else-if="showFilters" class="form-group col-md-2"></div> -->
        <!-- <div class="form-group col-md-2" v-if="showFilters" style = "margin:0px">
				<multiselect
					v-model="selectedTag"
					:options="tagsList"
					:show-no-results="true"
					ref="multiselect"
					label="title"
					track-by="id"
					open-direction="bottom"
					:taggable="false"
					placeholder="All Tags"
					class="form-control multi-dropdown"
					selectLabel = ""
					selectedLabel = ""
					@select = "selectTag($event)"
					@remove = "resetTag()"
					/>
			</div> -->
        <div v-if="!showFilters" class="form-group col-md-2"></div>

        <div v-if="showFilters"></div>
        <div
          v-if="
            showAssociatedFilter &&
            !showFilters &&
            $route.name == 'addToCampaign'
          "
        ></div>
        <div class="adv_fil_wrap">
          <PrestigeCampaignFilter style="" v-if="showFilters && $store.state.isUserPrestige" />
          <FilterCamp style="" v-if="showFilters && !$store.state.isUserPrestige" :profileTags="tagsList" :countryList="countryList" :searchSpecialists="searchSpecialists"/>
        </div>
        <div>
          <div class="head_search">
            <object
              data="assets/img/search.svg"
              style="height: 18px; width: 18px; margin-left: 5px"
            ></object>
          </div>
          <div class="ghost" @click="getCampaignListSearch()"></div>
          <div class="head_search_inp">
            <input
              type="search"
              class="search"
              id="search"
              v-model="searchFilterString"
              placeholder="Name"
              @keyup.enter="getCampaignListSearch()"
              autocomplete="off"
              style="border: none; outline: none; padding: 7px 0px 5px 10px"
            />
          </div>
          
        </div>

        <!-- <div class="form-group row col-md-3"  style = "margin:0px">
				<div class="form-group col-md-7 search-block" style = "padding: 0px;margin: 0px">

					<input type="search" class="form-control search" id="search" v-model="searchFilterString"  placeholder="Search" @keyup.enter="getCampaignListSearch()"  />
				</div>
				<div class="form-group col-md-5 search-button" style="margin:0px;padding:0px" v-if="showFilters">
					<button class="btn btn-primary "  @click="getCampaignListSearch()"
						onclick="javascript:goToPage(1);" >
						Search
					</button>
					<FilterCamp style="" v-if="showFilters"/>
				</div>

			</div> -->

        <!-- <div class="form-group col-md-1" v-if="showFilters">
                <select
                    class="form-control sorting"
                    id="orderBy"
                    v-model="selectedSortOrder"
                    @change="getCampaignList()"
                >
                    <option value>---Sort---</option>
                    <option value="asc">Ascending</option>
                    <option value="desc">Descending</option>
                </select>
            </div> -->

        <!-- <div class="form-group col-md-2" v-if="showFilters && showBrandFilter">
                <select
                    class="form-control brand-name"
                    id="brandFilter"
                    v-model="selectedBrandProfle"
                    @change="getCampaignList()"
                >
                    <option value>All Brand Profiles</option>
                    <option
                        v-for="item in brandProfileList"
                        :key="item.id"
                        :value="item.id"
                    >{{ item.name }}</option>
                </select>
            </div> -->
      </template></template
    ></CommonHeader
  >
</template>
        


<script>
import ProductListChipView from "@/components/product/ProductListChipView";
import FilterCamp from "@/components/campaign-list/CampaignFilter.vue";
import PrestigeCampaignFilter from "@/components/campaign-list/PrestigeCampaignFilter.vue"
import Multiselect from "vue-multiselect";
import CommonHeader from "@/components/CommonHeader.vue";

export default {
  name: "CampaignListHeader",
  data() {
    return {
      productList: [],
      showCampignGroupFilter: false,
      prodName: "",
      selectedVendorFilter: [],
      selectedCampaignGroupFilter: [],
      selectedBrand: [],
      selectedCountry: [],
      associateList: ["All", "Non-associated", "Associated"],
      tagsList: [],
      countryList: [],
      searchSpecialists: [],
    };
  },
  props: {
    showFilters: Boolean,
    showAssociatedFilter: Boolean,
  },
  components: {
    ProductListChipView,
    FilterCamp,
    Multiselect,
    CommonHeader,
    PrestigeCampaignFilter
  },
  mounted() {
    console.log(this.$route.query); 
    this.getData();
    this.prodName = this.$route.params.productTitle
      ? atob(this.$route.params.productTitle)
      : "Campaigns";
    this.$store.dispatch("getAllVendor");
    this.$store.dispatch("profileBrandList");

    if (
      this.$store.state.selectedBrandProfle &&
      this.$store.state.profileBrandList
    ) {
      this.showCampignGroupFilter = true;
      this.selectedBrand = this.$store.state.profileBrandList.filter(
        (e) => e.ams_profile_id == this.$store.state.selectedBrandProfle
      );

      if (
        this.$store.state.campaignGroupFilterList == undefined ||
        this.$store.state.campaignGroupFilterList.length == 0
      ) {
        let payload = { isOrphan: true };
        payload.fromBrand = true;
        payload.brand_id =
          this.selectedBrand && this.selectedBrand.length
            ? this.selectedBrand[0].id
            : "";
        let vm = this;
        this.$store
          .dispatch("campaign/getCampaignGroupFilterList", payload)
          .then((res) => {
            vm.selectedCampaignGroupFilter = res.filter(
              (e) => e.id == vm.$store.state.selectedCampaignGroupFilter
            );
          });
      } else {
        this.selectedCampaignGroupFilter =
          this.$store.state.campaignGroupFilterList.filter(
            (e) => e.id == this.$store.state.selectedCampaignGroupFilter
          );
      }
    }
    if(this.$store.state.isUserPrestige){
      this.selectedBrand = [{"id":"118","name":"Prestige Brands-US (vendor)","ams_profile_id":this.$store.state.campaign.prestigeProfileId}];
      
    }

    // if(this.showFilters){
    // 	this.getCampaignList();
    // }
  },
  computed: {
    selectedAssociateFilter: {
      get() {
        return this.$store.state.campaign.selectedAssociateFilter;
      },
      set(val) {
        //sessionStorage.setItem("campaign:showPerPage", 100);
        this.$store.state.currentPageNumber = 1;
        this.$store.state.campaign.selectedAssociateFilter = val;
      },
    },
    selectedCampaignList: {
      get() {
        return this.$store.state.campaign.campaignToAddToGroupList;
      },
      set(val) {
        this.$store.state.campaign.campaignToAddToGroupList = val;
      },
    },
    actionSelectionControl: {
      set(val) {
        this.$store.state.campaign.actionSelectionControl = val;
      },
      get() {
        return this.$store.state.campaign.actionSelectionControl;
      },
    },
    selectedProducts() {
      return this.$store.state.product.selectedProducts;
    },
    brandProfileList() {
      return this.$store.state.brandProfileList;
    },
    vendorsList() {
      let data = this.$store.state.vendorList.filter((e) => e.name);
      if (data && data.length && data[0].id != "all")
        data.unshift({ id: "all", name: "All Vendor" });
      return data;
    },
    brandList() {
      let data = this.$store.state.profileBrandList.filter((e) => e.name);
      if (data && data.length && data[0].id != "all")
        data.unshift({ id: "all", name: "All Profiles" });
      if(this.$store.state.isUserPrestige){
        data = data.filter(x=>x.ams_profile_id==this.$store.state.campaign.prestigeProfileId);
      }
      return data;
    },
    campaignGroupFilterList() {
      let data = this.$store.state.campaign.campaignGroupFilterList;
      if (data && data.length && data[0].id != "all")
        data.unshift({ id: "all", name: "All Campaign Group" });
      return data;
    },
    selectedBrandProfle: {
      set(val) {
        this.$store.commit("setSelectedBrandProfile", val);
      },
      get() {
        return this.$store.state.selectedBrandProfle;
      },
    },
    // selectedVendorFilter: {
    //     set(val) {
    //
    // 		if(val == ""){
    // 			this.$store.state.selectedCampaignGroupFilter = ""
    // 			this.showCampignGroupFilter = false
    // 		}
    // 		else{
    //         //    this.$store.state.selectedCampaignGroupFilter = ""
    // 			this.showCampignGroupFilter = true
    // 		}
    // 		this.$store.state.selectedVendorFilter = val;
    //         this.$store.commit("setSelectedVendorFilter", val);
    //         //this.$store.commit("setSelectedBrandProfile", "");
    //         if (val != "") {
    //             this.$emit("isShowAddToCampaignButton", true);
    // 			let payload = {isOrphan:true}
    // 			let vm = this;
    // 			if(!this.$store.state.selectedCampaignGroupFilter){
    // 				this.$store.dispatch("campaign/getCampaignGroupFilterList", payload)
    // 			}
    //
    //             // this.$store
    //             //     .dispatch("getAllBrandProfile", payload)
    //             //     .then(res => {
    //             //         //this.brandProfileList()
    //             //     });
    //         } else {
    //         //    this.$store.commit("setSelectedBrandProfile", "");
    //             this.$emit("isShowAddToCampaignButton", false);
    //         }
    //         //console.log('selectedVendorFilter', this.selectedVendorFilter);
    //     },
    //     get() {
    //
    // 		if(this.$store.state.selectedCampaignGroupFilter){
    // 			this.showCampignGroupFilter = true
    // 		}
    //         return this.$store.state.selectedVendorFilter;
    //     }
    // },
    showBrandFilter: {
      set(val) {
        this.showBrandFilter = val;
      },
      get() {
        //return this.$store.getters['getSelectedVendorFilter']
        return this.$store.state.selectedVendorFilter ? true : false; // store getter not giving right response giving old value
      },
    },
    // selectedCampaignGroupFilter: {
    //     set(val) {
    //
    //         // sessionStorage.setItem(
    //         //     "campaign:selectedCampaignGroupFilter",
    //         //     val
    //         // );
    // 		this.$store.state.selectedCampaignGroupFilter = val
    // 		 this.getCampaignList();
    //     },
    //     get() {
    //
    //         // if (
    //         //     sessionStorage.getItem(
    //         //         "campaign:selectedCampaignGroupFilter"
    //         //     )
    //         // ) {
    //         //     return sessionStorage.getItem(
    //         //         "campaign:selectedCampaignGroupFilter"
    //         //     );
    //         // } else {
    //             return this.$store.state.selectedCampaignGroupFilter;
    //     //    }
    //     }
    //},
    selectedSortOrder: {
      set(val) {
        sessionStorage.setItem("campaign:selectedSortOrder", val);
        //this.$store.state.selectedSortOrder = val
      },
      get() {
        if (sessionStorage.getItem("campaign:selectedSortOrder")) {
          return sessionStorage.getItem("campaign:selectedSortOrder");
        } else {
          return this.$store.state.selectedSortOrder;
        }
      },
    },
    searchFilterString: {
      set(val) {
        //
        if (!val) {
          this.$store.state.searchFilterString = val;
          this.getCampaignList();
        } else {
          this.$store.state.searchFilterString = val;
        }
      },
      get() {
        //
        // if (sessionStorage.getItem("campaign:searchFilterString")) {
        //     return sessionStorage.getItem(
        //         "campaign:searchFilterString"
        //     );
        // } else {
        return this.$store.state.searchFilterString;
        //}
      },
    },
    selectedTag: {
      set(data) {
        if (data && data.id == "all") {
        } else {
          this.$store.state.selectedTag = (data || {}).title;
        }
      },
      get() {
        let tag = this.tagsList.filter(
          (tag) => tag.title == this.$store.state.selectedTag
        );
        return tag;
      },
    },
  },
  methods: {
    getData() {
      let vm = this;
      this.$store
        .dispatch("campaign/getCampTagList", {ams_profile_id : vm.selectedBrandProfle})
        .then((data) => {
          if (data && data.length && data[0].id != "all")
            data.unshift({id:"untagged",title:"Untagged"})
            data.unshift({ id: "all", title: "All Tags" });
          vm.tagsList = data;
        });

      this.$store
        .dispatch("campaign/getCountryList", {ams_profile_id : vm.selectedBrandProfle})
        .then((data) => {
          vm.countryList = data;
          console.log(vm.countryList)
        });

      this.$store
        .dispatch("campaign/getSearchSpecialists", {ams_profile_id : vm.selectedBrandProfle})
        .then((data) => {
          vm.searchSpecialists = data;
          console.log(vm.searchSpecialists)
        });
    },
    selectTag(data) {
      console.log(data)
      this.resetCampAction();
      this.$store.state.currentPageNumber = 1;
      if (data.id == "all") {
        this.resetTag();
        this.$store.dispatch("campaign/getCampaignList");
      } else {
        this.selectedTag = data;
        let payload = {
          // tag:data.id
        };
        this.$store.dispatch("campaign/getCampaignList", payload);
      }
    },
    resetTag() {
      this.resetCampAction();
      this.selectedTag = [];
      this.$store.dispatch("campaign/getCampaignList");
    },
    getCampaignList() {
      //this.selectedVendorFilter();
      this.$store.state.currentPageNumber = 1;
      // if(data){
      // 	let payload = {
      // 		vendorId:data.id
      // 	}
      // 	this.$store.dispatch("campaign/getCampaignList", payload);
      //
      // }
      // else{

      if (this.showFilters) {
      this.$store.dispatch("campaign/getCampaignList");
      } else {
        this.$emit("getList");
      }

      //}
      console.log("selectedVendorFilter", this.selectedVendorFilter);
      // if(callType == 'vendor'){
      // 	let payload = {isOrphan:true}
      // 	this.$store.dispatch("campaign/getCampaignGroupFilterList", payload);
      // }
    },
    getCampaignListByGroup(val) {
      this.resetCampAction();
      this.$store.state.currentPageNumber = 1;
      if (val.id == "all") {
        this.resetCampaignFilter();
      } else {
        this.$store.state.selectedCampaignGroupFilter = val.id;
        this.getCampaignList();
      }
    },
    getCampaignListSearch() {
      this.resetCampAction();
      console.log("Search Clicked!");
      //if (this.searchFilterString.trim().length > 0) {
      this.getCampaignList();
      //}
    },
    addNewCampaign() {
      this.$store.commit("showLoadingSpinner", null, {
        root: true,
      });
      this.$router.push("/addEditCampaign");
    },
    resetCampaignGroup() {
      this.$store.state.selectedCampaignGroupFilter = "";
    },
    resetFilter() {
      this.$store.state.selectedCampaignGroupFilter = "";
      this.$store.state.selectedBrandProfle = "";
      this.$store.state.selectedVendorFilter = "";
      this.selectedVendorFilter = [];
      this.selectedBrand = [];
      this.selectedCampaignGroupFilter = [];
      this.showCampignGroupFilter = false;
      this.resetCampAction();
      this.getCampaignList();
    },
    resetCampAction() {
      this.actionSelectionControl = false;
      this.selectedCampaignList = [];
    },
    setVendor(val) {
      this.$store.state.currentPageNumber = 1;
      let payload = { isOrphan: true };
      this.selectedCampaignGroupFilter = [];
      if (val.id == "all") {
        this.$store.dispatch("profileBrandList");
        this.resetFilter();
      } else {
        this.$store.state.selectedVendorFilter = val.id;
        this.showCampignGroupFilter = true;
        this.$store.dispatch("campaign/getCampaignGroupFilterList", payload);
        let params = {
          go_vendor_cd: val.id,
        };
        this.$store.dispatch("profileBrandList", params);
      }
      this.getCampaignList();
    },
    getBrand(val) {
      this.resetCampAction();
      this.selectedCampaignGroupFilter = [];
      let payload = { isOrphan: true };

      if (val.id == "all") {
        this.resetFilter();
        this.$store.dispatch("profileBrandList");
      } else {
        this.$store.state.selectedBrandProfle = val.ams_profile_id;
        this.showCampignGroupFilter = true;

        payload.fromBrand = true;
        payload.brand_id = val.id;
        this.$store.dispatch("campaign/getCampaignGroupFilterList", payload);
      }
      this.getCampaignList();
      this.getData();
    },
    resetCampaignFilter() {
      this.$store.state.selectedCampaignGroupFilter = "";
      this.selectedCampaignGroupFilter = [];
      this.resetCampAction();
      this.getCampaignList();
    },
  },
};
</script>